module.exports = __webpack_public_path__ + "static/img/light.ccbb6cbd.svg";